import { useEffect } from "react";
import Tealium, { EventLog } from "@4tn/webx-analytics";
import getPageCategory, { getRouteSlug } from "./getPageCategory";

interface PageViewProps {
  isLoading: boolean;
  data: unknown;
  error?: Error | null;
}

const usePageView = ({ isLoading, data, error }: PageViewProps) => {
  useEffect(() => {
    if (isLoading || (data === undefined && !error)) return;
    if (EventLog.getLastEvent("view")?.page_url !== document.location.href) {
      const pageCategory = getPageCategory(
        document.location.pathname,
        (data as Article)?.hasVideo ?? false,
        !!(data as Article)?.sponsor ?? false
      );
      const pageId = getRouteSlug(document.location.pathname);

      Tealium.setDataLayer({
        page_category: pageCategory,
        page_id: pageId,
      });
      Tealium.view({ event_value: document.title, page_category: pageCategory, page_id: pageId });
    }
  }, [isLoading, data, error]);
};

export default usePageView;
